import React, { useContext } from 'react';
import { withFormulas } from '../hocs/with-formulas';
import { PageContext } from '../providers/page-provider';
import { HealthAssesment } from '../providers/health-assesment-provider';
import { HealthAssesmentCalculator } from '../layouts/health-assesment-calculator';
import './pages.scss';
import {
  ButtonNext,
  StepSummary,
  StepSlider
} from '../components'

export const StepFive = ({formulas}) => {
  const { handleNextPage, handlePreviousPage } = useContext(PageContext);
  const { addHealthAssesmentData, healthAssesmentData } = useContext(HealthAssesment);
  const titleStep = "Business Information";
  const summaryStep = "You are almost done! Help us understand a little bit more about your company";
  const annualRevenue = healthAssesmentData.general.a;
  const selectSystem = healthAssesmentData.general.b;
  const numberEmployees = healthAssesmentData.general.c;
  const firstName = healthAssesmentData.general.d;
  const lastName = healthAssesmentData.general.e;
  const jobTitle = healthAssesmentData.general.f;
  const email = healthAssesmentData.general.g;
  const arCostsPoints = formulas.getArCostsTotalPoints();
  const cashFlowPoints = formulas.getCashFlowTotalPoints();
  const scalabilityPoints = formulas.getScalabilityTotalPoints();
  const resiliencePoints = formulas.getResilienceTotalPoints();
  const overallPoints = arCostsPoints + cashFlowPoints + scalabilityPoints + resiliencePoints;

  const handleNextClick = () => {
    setScores();
    handleNextPage({from: "STEP_FIVE", to: "SCORE_PAGE"});
  };

  const setScores = () => {
    addHealthAssesmentData({question: "score", name: "overallScore", value: overallPoints});
    addHealthAssesmentData({question: "score", name: "arCostsScore", value: arCostsPoints});
    addHealthAssesmentData({question: "score", name: "cashFlowScore", value: cashFlowPoints});
    addHealthAssesmentData({question: "score", name: "scalabilityScore", value: scalabilityPoints});
    addHealthAssesmentData({question: "score", name: "resiliencyScore", value: resiliencePoints});
  };

  const handleBackClick = () => {
    handlePreviousPage({to: "STEP_FOUR"});
  };

  const handleChange = (question) => (event) => {
    const { name, value } = event.target;
    addHealthAssesmentData({question, name, value});
  }

  const disableButton = () => {
    const isAnnualRevenueEmpty = annualRevenue.length === 0;
    const isSelectSystemEmpty = selectSystem.length === 0;
    const isnumberEmployeesEmpty = numberEmployees.length === 0;
    const isFirstNameEmpty = firstName.length === 0;
    const isLastNameEmpty = lastName.length === 0;
    const isJobTitleEmpty = jobTitle.length === 0;
    const isEmailEmpty = email.length === 0;

    return isFirstNameEmpty || isLastNameEmpty || isJobTitleEmpty || isEmailEmpty || isSelectSystemEmpty || isAnnualRevenueEmpty || isnumberEmployeesEmpty;
  }

  return (
    <HealthAssesmentCalculator>
      <div className="fieldset step-five">
        <div className="questions">
          <div className="column-left">
            <StepSummary stepNumber="5" stepTitle={titleStep} stepInfo={summaryStep} />
            <p className="text-05-sky-blue-bold">Select your Annual Revenue</p>
            <StepSlider
              min={1}
              max={1000}
              minValue="<$1M"
              maxValue="$1B"
              currency={true}
              valueType="M"
              name="a"
              initalValue={healthAssesmentData.general.a}
              onChange={handleChange("general")}
              idSlider="5a-slide"
              idValue="5a-value"
            />

            <div className="select-system">
              <select name="b" onChange={handleChange("general")} value={healthAssesmentData.general.b}>
                <option value="" disabled hidden>ERP or Accounting system</option>
                <option value="Netsuite">Netsuite</option>
                <option value="Xero">Xero</option>
                <option value="Microsoft Dynamics">Microsoft Dynamics</option>
                <option value="Financial Force">FinancialForce</option>
                <option value="Intacct">Intacct</option>
                <option value="SAP">SAP</option>
                <option value="Infor">Infor</option>
                <option value="Plex">Plex</option>
                <option value="Other">Other</option>
              </select>
              <i className="fa fa-angle-down"></i>
            </div>

            <div className="select-system">
              <select name="c" onChange={handleChange("general")} value={healthAssesmentData.general.c}>
                <option value="" disabled hidden>Number of Employees</option>
                <option value="1-5">1-5</option>
                <option value="5-25">5-25</option>
                <option value="25-50">25-50</option>
                <option value="50-100">50-100</option>
                <option value="100-500">100-500</option>
                <option value="500-1000">500-1000</option>
                <option value="1000+">1000+</option>
              </select>
              <i className="fa fa-angle-down"></i>
            </div>

            <input
              type="text"
              className="normal-input"
              placeholder="First Name"
              name="d"
              onChange={handleChange("general")}
              value={healthAssesmentData.general.d}
            />
            <input
              type="text"
              className="normal-input"
              placeholder="Last Name"
              name="e"
              onChange={handleChange("general")}
              value={healthAssesmentData.general.e}
            />
          </div>

          <div className="column-right">
            <div className="image-preview">
              <img className="img-background" src={require(`../../styles/img/AR-screens_01.png`)} alt="buisiness-info"/>
            </div>
            <input
              type="text"
              className="normal-input"
              placeholder="Job title"
              name="f"
              onChange={handleChange("general")}
              value={healthAssesmentData.general.f}
            />

            <input
              type="email"
              className="normal-input"
              placeholder="Email"
              name="g"
              onChange={handleChange("general")}
              value={healthAssesmentData.general.g}
            />
          </div>

        </div>
        <div className="calculate-health">
          <button className="btn-white-normal-back" onClick={handleBackClick}><i className="fa fa-angle-left"></i> Back</button>
          <ButtonNext disabled={disableButton()} onClick={handleNextClick}>Calculate my AR Health</ButtonNext>
        </div>
      </div>
    </HealthAssesmentCalculator>
  )
}

export const StepFiveWithFormulas = withFormulas(StepFive);
